import { appLog } from '@shared/common/logging/app-log.util';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';
import './polyfills';
import { RootModule } from './root.module';
import { tryCaptureOutlookOAuthCallback } from '@app/shared/utils/outlook-oauth-bootstrap';

// Capture Outlook popup OAuth before Angular auth guards can drop the ?code=.
if (tryCaptureOutlookOAuthCallback()) {
    // Popup handed the result to My Profile; skip bootstrapping this window.
} else {
if (environment.production) {
    enableProdMode();
}
const bootstrap = () => {
    return platformBrowserDynamic().bootstrapModule(RootModule);
};
/* "Hot Module Replacement" is enabled as described on
 * https://medium.com/@beeman/tutorial-enable-hrm-in-angular-cli-apps-1b0d13b80130#.sa87zkloh
 */
if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap); //HMR enabled bootstrap
    }
    else {
        appLog.error('HMR is not enabled for webpack-dev-server!');
        // console.log('Are you using the --hmr flag for ng serve?');
    }
}
else {
    bootstrap(); //Regular bootstrap
}
}
